// extracted by mini-css-extract-plugin
export default {"form":"HttpMonitorForm_form__7tt5R"};